import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Directive,
  ElementRef,
  HostBinding,
  HostListener,
  input,
  output,
  Renderer2,
  signal,
  ViewContainerRef,
} from '@angular/core';
import { Icon } from '../components/icon/icon.component';
import { toObservable } from '@angular/core/rxjs-interop';

@Directive({
  selector: '[appScrollGuide]',
})
export class ScrollGuideDirective implements AfterViewInit {
  @HostBinding('class') get hostClass() {
    if (this.scrollEnabled()) {
      return 'overflow-x-auto relative';
    }

    return '';
  }

  @HostListener('scroll', ['$event']) onScroll(ev: any) {
    // 맨 끝으로 스크롤 했을 때 감지
    const scrollLeft = ev.target.scrollLeft;
    const isScroll = scrollLeft > 0;
    this.scrollEnd.set(isScroll);
  }

  scrollEnd = signal(false);
  scrollEnd$ = toObservable(this.scrollEnd);

  scrollEnabled = input<boolean>(true);

  constructor(
    private readonly el: ElementRef<HTMLElement>,
    private readonly renderer: Renderer2,
    private readonly viewContainerRef: ViewContainerRef,
    private readonly changeRef: ChangeDetectorRef,
  ) {}

  ngAfterViewInit(): void {
    this.scrollEnd$.subscribe({
      next: (value) => {
        if (!value) {
          this.create();
        } else {
          this.remove();
        }
      },
    });
  }

  create() {
    if (!this.scrollEnabled()) return;

    if (
      this.el.nativeElement.scrollWidth <= this.el.nativeElement.clientWidth
    ) {
      this.remove();
      return;
    }

    const componentRef =
      this.viewContainerRef.createComponent(ScrollGuideComponent);
    const element = componentRef.location.nativeElement as HTMLElement;
    componentRef.instance.scrollTo.subscribe(() => {
      this.el.nativeElement.scrollTo({
        left: this.el.nativeElement.scrollWidth,
        behavior: 'smooth',
      });
    });
    this.renderer.appendChild(this.el.nativeElement, element);
    this.changeRef.detectChanges();
  }

  remove() {
    this.viewContainerRef.clear();
  }
}

@Component({
  selector: 'app-scroll-guide',
  template: `
    <div
      (click)="handleClick()"
      class="z-[999] background lg:hidden absolute -right-1 top-1/2 min-w-[4rem] h-full transform -translate-y-1/2 flex items-center justify-center pointer-events-none"
    >
      <app-icon
        name="material-symbols:keyboard-double-arrow-right"
        class="text-gray-400 animate-pulse"
      />
    </div>
  `,
  imports: [Icon],
  styles: `
    .background {
      background: linear-gradient(
        90deg,
        rgba(255, 255, 255, 0) 13.64%,
        #fff 46.06%
      );
    }
  `,
})
class ScrollGuideComponent {
  scrollTo = output<void>();

  handleClick() {
    this.scrollTo.emit();
  }
}
